







import Vue from 'vue';
export default Vue.extend({
  props: {
    characteristicTitle: {
      type: String,
    },
    isLabelProp: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClickCharacteristic(): void {
      this.$emit(
        'onClickCharacteristic',
        this.characteristicTitle,
        this.isLabelProp,
      );
    },
  },
});
